import type { DocPageContent } from '../types';

/**
 * "Approved websites" — Dashboard section (ADR-0074).
 * Reconciled from apps/web `features/allowed-sites` (route
 * `/settings/allowed-sites`) and the `allowedSites.*` catalog.
 *
 * The default — the assistant reads nothing outside the workspace — is the
 * first sentence, because it is the fact most readers need and the one an
 * empty page cannot convey on its own.
 */
export const DASHBOARD_ALLOWED_SITES_PAGE: DocPageContent = {
  slug: 'dashboard/allowed-sites',
  titleKey: 'docs.dashboard.sites.title',
  descriptionKey: 'docs.dashboard.sites.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.dashboard.sites.lead' },

    { kind: 'heading', level: 2, id: 'when', textKey: 'docs.dashboard.sites.when.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.sites.when.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.sites.when.item.status',
        'docs.dashboard.sites.when.item.pricing',
        'docs.dashboard.sites.when.item.partner',
      ],
    },

    { kind: 'heading', level: 2, id: 'entry', textKey: 'docs.dashboard.sites.entry.heading' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.dashboard.sites.entry.domain.term',
          descKey: 'docs.dashboard.sites.entry.domain.desc',
        },
        {
          termKey: 'docs.dashboard.sites.entry.path.term',
          descKey: 'docs.dashboard.sites.entry.path.desc',
        },
        {
          termKey: 'docs.dashboard.sites.entry.robots.term',
          descKey: 'docs.dashboard.sites.entry.robots.desc',
        },
        {
          termKey: 'docs.dashboard.sites.entry.note.term',
          descKey: 'docs.dashboard.sites.entry.note.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'limits', textKey: 'docs.dashboard.sites.limits.heading' },
    { kind: 'paragraph', textKey: 'docs.dashboard.sites.limits.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.dashboard.sites.limits.item.two',
        'docs.dashboard.sites.limits.item.public',
        'docs.dashboard.sites.limits.item.read',
        'docs.dashboard.sites.limits.item.revoke',
      ],
    },

    {
      kind: 'callout',
      tone: 'caution',
      titleKey: 'docs.dashboard.sites.cost.title',
      textKey: 'docs.dashboard.sites.cost.body',
      links: {
        usage: { target: { docSlug: 'billing/usage' }, labelKey: 'docs.dashboard.sites.cost.link' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.dashboard.sites.next.knowledge.title',
          textKey: 'docs.dashboard.sites.next.knowledge.text',
          to: { docSlug: 'dashboard/knowledge' },
        },
        {
          titleKey: 'docs.dashboard.sites.next.labs.title',
          textKey: 'docs.dashboard.sites.next.labs.text',
          to: { docSlug: 'dashboard/labs' },
        },
      ],
    },
  ],
};
